import { createAsyncThunk } from "@reduxjs/toolkit";
import APIClient from "../api";

export const authLogin = createAsyncThunk("auth/login", async (values: any) => {
  const result = await APIClient.post("/auth/login", values);
  return result.data;
});
